import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { LazyMotion, domAnimation } from 'motion/react'
import { AuthProvider } from '@/contexts/AuthProvider'
import { AdminShellProvider } from '@/contexts/AdminShellContext'
import { AppRouter } from '@/router'
import ErrorBoundary from '@/components/ui/ErrorBoundary'
import { useColorScheme } from '@/hooks/use-color-scheme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,     // 2 minutes (PRD §25)
      gcTime: 10 * 60 * 1000,       // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  // Apply color-scheme (dark/light class on <html>) at the app root
  // so it's available before any layout component mounts.
  useColorScheme()

  return (
    <ErrorBoundary>
      <LazyMotion features={domAnimation} strict>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AdminShellProvider>
              <AppRouter />
            </AdminShellProvider>
          </AuthProvider>
        </QueryClientProvider>
      </LazyMotion>
    </ErrorBoundary>
  )
}

export default App

